<template>
  <div class="ng-file-box">
    <div class="ng-file">
      <div class="ng-file-category">
        <span v-if="hasCategory">{{ i18nRefName(pFile.fileCategoryRef, pLanguage) }}</span>
        <span v-else>{{ 'dictionary.file.category.none' | i18nText(pDictionary) }}</span>
      </div>
      <a :href="downloadFileUrl" :target="downnloadFileTarget" :title="downnloadFileTitle"
         :onclick="openFileOnClick" :class="{'preview' : pFile.image}">
        <div :id="'icon' + pFile.id" class="ng-icon hide">
          <file-preview-icon :p-file-type="pFile.fileType"></file-preview-icon>
        </div>
        <div :id="'image' + pFile.id" class="ng-image" style="text-align: center; vertical-align: top;">
          <img :src="downloadThumbnailUrl" :alt="pFile.name" :title="pFile.name" :onerror="downloadThumbnailOnError"/>
        </div>
      </a>
      <div class="ng-file-name">
        <div :title="pFile.fileName" style="width: 180px; overflow-x: hidden; white-space: nowrap; text-overflow: ellipsis;">
          <a :href="downloadFileUrl" :target="downnloadFileTarget" :title="downnloadFileTitle"
             :onclick="openFileOnClick" :class="{'preview' : pFile.image}">
            {{ pFile.fileName }}
          </a>
        </div>
        <div>
          <p class="audit help-block"><span>{{ pFile.auditInfo.createdByUser }}</span></p>
          <p class="audit help-block"><span>{{ pFile.auditInfo.createdOnDateLongText }}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import refHelpers from '@/helpers/ref-helpers'
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import FilePreviewIcon from "@/components/modules/file-module/file/preview/FilePreviewIcon";

export default {
  name: "FilePreview",
  components: {FilePreviewIcon},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pFile: {
      type: Object,
      required: true
    },
    pFileListPreviewsClass: {
      type: String,
      default: function () {
        return "formFileListPreviews";
      }
    }
  },
  computed: {
    hasCategory: function () {
      return refHelpers.isValidRef(this.pFile.fileCategoryRef);
    },
    downloadFileUrl: function () {
      return this.pUrls['downloadFile'] + '?dataId=' + this.pFile.id + "&download=true";
    },
    downnloadFileTarget: function () {
      return 'file_' + this.pFile.id;
    },
    downnloadFileTitle: function () {
      return this.pFile.name;
    },
    openFileUrl: function () {
      return this.pUrls['downloadFile'] + '?dataId=' + this.pFile.id;
    },
    openFileOnClick: function () {
      return "openWindow('file_" + this.pFile.id + "', '" + this.openFileUrl + "', 1064, 768, null); return false;"
    },
    downloadThumbnailUrl: function () {
      return this.pUrls['downloadFileThumbnail'] + '?dataId=' + this.pFile.id + "&thumbnailSize=200";
    },
    downloadThumbnailOnError: function () {
      return "showHide('#" + this.pFileListPreviewsClass + " #icon" + this.pFile.id + "', '#" + this.pFileListPreviewsClass + " #image" + this.pFile.id + "');"
    }
  }
}
</script>

<style scoped>

</style>